// extracted by mini-css-extract-plugin
export var button = "_8l-7";
export var buttonRow = "_8l-6";
export var fadeIn = "_8l-1";
export var gradient = "_8l-0";
export var panel = "_8l-2";
export var panelIn = "_8l-3";
export var subtitle = "_8l-5";
export var title = "_8l-4";